import React, { useEffect, useState } from 'react';
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import "./CongressSection.css";
import parse from "html-react-parser"

const CongressSection = ({webpageData}) => {
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
  const congressData = webpageData?.congressSection || {};
  const sponsorData = webpageData?.sponsorSection || {};
  const [userLocation, setUserLocation] = useState("unknown");
  
  // Check if current time is after July 8, 2025 5PM ET
  const isAfterRegistrationDeadline = () => {
    const now = new Date();
    const deadline = new Date('2025-07-08T17:00:00-04:00'); // July 8, 2025 5PM ET
    // const deadline = new Date('2025-07-08T00:35:00-07:00');
    return now >= deadline;
  };
  
  const showTicketButton = !isAfterRegistrationDeadline();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_MAXMIND,
          {},
          {
            headers: { "Content-Type": "application/json" },
            timeout: 5000,
          }
        );

        if (
          response.data !== "IP Not Available" &&
          response.data !== "Invalid Country"
        ) {
          
          setUserLocation(JSON.stringify(response.data)); 
        } else {
          setUserLocation("User is not from US");
        }
      } catch (error) {

      }
    };

    fetchData();
  }, []);


  // Lambda interaction on sponsor PDF download
  const incrementPdfCount = async () => {
    const webpageName = "https://www.ussaic.com";
    const filePath = sponsorData?.ctaBanner?.buttonUrl
      ? new URL(sponsorData.ctaBanner.buttonUrl, window.location.origin).pathname
      : "unknown";

    try {
      await fetch(process.env.REACT_APP_DOWNLOADCOUNT_LAMBDA_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          webpageName,
          userLocation,
          filePath
        })
      });
    } catch (error) {

    }
  };

  const handleRegisterClick = (e) => {
    e.preventDefault(); 
    
    // Try to use the global function if available
    if (typeof window.scrollToTickets === 'function') {
      window.scrollToTickets();
    } else {
      // Fallback: First scroll to bottom to ensure components are loaded
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
      
      // Then try again after a delay
      setTimeout(() => {
        if (typeof window.scrollToTickets === 'function') {
          window.scrollToTickets();
        }
      }, 1000);
    }
  };

  return (
    <div className="cg-section">
      <Container fluid className="cg-container">
        <Row className="cg-row">
          <Col lg={6} md={12} className="cg-image-col">
            <div className="cg-image-wrapper desktopimageview">
              <img 
                src={imgCDNURL + "USSAC_Seats.webp"} 
                alt="Lecture hall with rows of seats, colorful lighting effects" 
                className="cg-main-image"
                loading="lazy"
              />
            </div>
          </Col>
          <Col lg={6} xl={6} xxl={5} md={12} className="cg-content-col">
            <p className="cg-small-text">{parse(congressData.tagline)}</p>
            <h3 className="cg-heading">{parse(congressData.heading)}</h3>
            <div className="cg-description">
            {congressData.description && congressData.description.paragraphs && 
                congressData.description.paragraphs.map((paragraph, index) => (
            <p key={index}>
              {parse(paragraph)}
            </p>
            ))
          }
          </div>
            <Col lg={6} md={12} className="cg-image-col">
            {/* <div className="cg-image-wrapper mobileimageview">
              <img 
                src={imgCDNURL + "USSAC_Seats.webp"} 
                alt={congressData.image.alt} 
                className="cg-main-image"
                loading="lazy"
              />
            </div> */}
          </Col>
            <Row className="cg-button-row">
              {showTicketButton && (
                <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                  <Button 
                    variant="primary" 
                    className="cg-button cg-ticket-button"
                    onClick={handleRegisterClick}
                  >
                   {parse(congressData?.getYourTicketBtn)}
                  </Button>
                </Col>
              )}
              <Col xs={12} sm={showTicketButton ? 6 : 12}>
                <Button 
                  variant="outline-primary" 
                  className="cg-button cg-sponsor-button"
                  href={imgCDNURL + "USSAIC_SponsorDeck_2025.pdf"}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    incrementPdfCount();
                  }}
                >
                 {parse(congressData?.becomeSponsorBtn)}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CongressSection;